import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  banners: [],
};

export const bannerSlice = createSlice({
  name: "bannerSlice",
  initialState,
  reducers: {
    setBanners: (state, action) => {
      state.banners = action.payload;
    },
  },
});

export const { setBanners } = bannerSlice.actions;

export default bannerSlice.reducer;
